(ns very.re-frame.event-log
  (:require
    [re-frame.interceptor :as intc]
    [oops.core :refer [oset!]]
    ))

;; a simple sliding buffer of events piped through a reframe system.  when the
;; number of events in the log exceeds the max allowed, splits the log in half
;; and appends the newest even to the halved log. this limits our calls to
;; subvec to only once every N/2 events instead of every event.
(def event-log (atom []))

(declare truncate)

(defn- truncate-coll
  "Recursively truncate a collection to a certain maximum length. Adds an
  ellipsis where truncation occurs."
  [coll]
  (let [max-length 5
        max-length-exceeded (> (count coll) max-length)
        coll' (if max-length-exceeded (take max-length coll) coll)]
    (cond
      (map? coll)
      (let [s (map (fn [[k v]] [(truncate k) (truncate v)]) coll')]
        (into {} (if max-length-exceeded
                   (concat s '([... ...]))
                   s)))
      (seq? coll)
      (let [s (map truncate coll')]
        (apply list (if max-length-exceeded
                      (concat s '(...))
                      s)))
      :else
      (let [s (map truncate coll')]
        (into (empty coll) (if max-length-exceeded
                             (concat s '(...))
                             s))))))

(defn- truncate-str
  "Truncate the string s if the length exceeds 20 characters and add an
  ellipsis."
  [s]
  (let [max-length 20]
    (if (> (count s) max-length)
      (str (subs s 0 max-length) "...")
      s)))

(defn- truncate
  "Truncate an object recursively."
  [x]
  (cond (coll? x) (truncate-coll x)
        (string? x) (truncate-str x)
        :else x))

(defn- truncate-event
  "Given an event vector [:event-name arg arg1... argN], trim the size of
  the args so as to not choke the logging process with enormous datasets."
  [event-vec]
  (let [event (first event-vec)
        args (rest event-vec)
        truncated (map truncate args)]
    (if (empty? args) event-vec
      (conj [event] truncated))))

(defn- clamp
  "Clamp the given vector to a max size of max, halving any overflows."
  [max v]
  (if (> (count v) max)
    (subvec v (- (count v) (/ max 2)))
    v))

(defn log [] (deref event-log))

(defn log! [max-events evt]
  (swap! event-log (fn [old] (conj (clamp max-events old) evt))))

(defn interceptor
  "An interceptor which keeps track of the most recent N events in the system."
  [max]
  (oset! js/window "!very.!_debug.!re_frame.!event_log.!log" log)
  (log! max [:init-event-log])
  (intc/->interceptor
    :id ::event-log
    :before (fn event-logger [context]
              (let [evt (intc/get-coeffect context :event)
                    truncd (truncate-event evt)]
                (log! max truncd)
                context))))

